import { useState, useEffect } from 'react';
import shortid from 'shortid';
import { produce } from 'immer';
export default function useRules(props) {
  const { thisCampaign, handleChange } = props;

  let [templateModels, setTemplateModels] = useState(
    thisCampaign.templates || []
  );

  useEffect(() => {
    handleChange({
      target: {
        name: 'templates',
        value: templateModels.length > 0 ? templateModels : undefined
      }
    });

  }, [templateModels]);

  const templateModel = {
    id: null,
    conditionOperator: 'OR',
    communicationTemplateUuid: '',
    scheduleDate: '',
    subConditionExpressions: []
  };

  const addTemplateModel = () => {
    let tempTemplateModal;
    if (thisCampaign.templates)
      tempTemplateModal = thisCampaign.templates;
    else
      tempTemplateModal = templateModels;
    setTemplateModels(() => {
      const newTemplateModels = [...tempTemplateModal];
      newTemplateModels.push({
        ...templateModel,
        id: shortid.generate()
      });
      return newTemplateModels;
    });
  };

  const deleteAndAdd = (dragIndex, dropIndex) => {
    setTemplateModels(templateModels => {
      const newTemplateModels = [...templateModels];
      newTemplateModels.splice(dropIndex, 0, thisCampaign.templates[dragIndex]);
      if (dragIndex > dropIndex)
        dragIndex = dragIndex + 1;
      newTemplateModels.splice(dragIndex, 1);
      return newTemplateModels;
    });
  };


  const deleteTemplateModel = id => {
    setTemplateModels(() => {
      const newTemplateModels = [...thisCampaign.templates];
      const removeIndex = newTemplateModels.findIndex(
        templateModel => templateModel.id === id
      );
      if (removeIndex >= 0 && removeIndex <= newTemplateModels.length - 1) {
        newTemplateModels.splice(removeIndex, 1);
      }
      return newTemplateModels;
    });
  };

  const updateTemplateModelProperty = (id, event) => {
    setTemplateModels(templateModels => {
      const newTemplateModels = produce(templateModels, drafttemplateModels => {
        const updateAtIndex = drafttemplateModels.findIndex(
          rule => rule.id === id
        );
        if (
          updateAtIndex >= 0 &&
          updateAtIndex <= drafttemplateModels.length - 1
        ) {
          drafttemplateModels[updateAtIndex][event.target.name] =
            event.target.value;
        }
      });
      return newTemplateModels;
    });
  };

  return {
    templateModels,
    addTemplateModel,
    deleteTemplateModel,
    updateTemplateModelProperty, deleteAndAdd
  };
}
